import ClientCarousel, {
  CarouselItem,
} from "@/components/common/ui/ClientCarousel";
import BlogCard from "./blog_card";
import { Heading } from "@/components/common/typography/Heading";
import { FlattenedPost } from "@/services/blog/blog.mapper";
import Link from "next/link";
import Typography from "@/components/common/typography";
import Button from "@/components/common/button";
// In your Blogs component
export type BlogsType = {
  title?: string;
  description?: string;
  posts: FlattenedPost[];
  press?: boolean;
  showButton?: boolean;
};

export default function Blogs({
  title,
  description,
  posts,
  press = false,
  showButton = true,
}: BlogsType) {
  return (
    <section
      data-testid={`horizontal-blog-section-block`}
      className="w-full max-w-screen-2xl mx-auto flex flex-col gap-4"
    >
      <header className="flex flex-col gap-9 contentContainer">
        <div className="lg:w-3/4">
          <Heading dataTestId="horizontal-blog-section-title" size="h2" as="h2">
            {title || "Car Detailing Tips & Guides"}
          </Heading>
          <Heading
            dataTestId="horizontal-blog-section-description"
            size="h6"
            as="h3"
            color="copyGray"
            className="mt-9"
          >
            {description ||
              "Car care tips from IDA certified pros with years of hands-on experience and over 12,000 five-star reviews."}
          </Heading>
        </div>
      </header>

      <section
        data-testid="horizontal-blog-section-carousel-area"
        className="flex flex-col sm:gap-10"
      >
        <ClientCarousel cursorGrab={false}>
          {posts.map((data, idx) => (
            <CarouselItem
              dataTestId={`carousel-blog-item-${idx}`}
              className={`${idx === posts.length - 1 ? "max-cw:!pr-0" : ""}`}
              key={`card-item-${idx}`}
            >
              <BlogCard
                cardDataTestId={`carousel-blog-card-${idx}`}
                cardDataImageTestId={`carousel-blog-card-image-${idx}`}
                cardDataCategoryTextTestId={`carousel-blog-card-blog-post-category-${idx}`}
                cardDataTitleTestId={`carousel-blog-card-title-${idx}`}
                cardDataDescriptionTestId={`carousel-blog-card-description-${idx}`}
                press={press}
                slug={data.slug}
                timeToRead={data.time_to_read}
                image={
                  data.thumbnail_image
                    ? data.thumbnail_image
                    : data.featured_image
                }
                title={data.title}
                description={data.post_summary}
                category={data.category}
                published={data.published_at}
              />
            </CarouselItem>
          ))}
        </ClientCarousel>

        <noscript>
          <div className="flex flex-row overflow-x-scroll contentContainer">
            {posts.map((data, idx) => (
              <CarouselItem
                dataTestId={`carousel-blog-item-${idx}`}
                className={`${idx === posts.length - 1 ? "max-cw:!pr-0" : ""}`}
                key={`card-item-${idx}`}
              >
                <BlogCard
                  cardDataTestId={`carousel-blog-card-${idx}`}
                  cardDataImageTestId={`carousel-blog-card-image-${idx}`}
                  cardDataCategoryTextTestId={`carousel-blog-card-blog-post-category-${idx}`}
                  cardDataTitleTestId={`carousel-blog-card-title-${idx}`}
                  cardDataDescriptionTestId={`carousel-blog-card-description-${idx}`}
                  press={press}
                  slug={data.slug}
                  timeToRead={data.time_to_read}
                  image={
                    data.thumbnail_image
                      ? data.thumbnail_image
                      : data.featured_image
                  }
                  title={data.title}
                  description={data.post_summary}
                  category={data.category}
                  published={data.published_at}
                />
              </CarouselItem>
            ))}
          </div>
        </noscript>

        {showButton && (
          <div className="contentContainer">
            <Link
              data-testid={`horizontal-blog-section-carousel-see-all-posts-button`}
              href="/blog"
              className="text-center lg:text-left w-fit "
            >
              <Button intent="primary" label="See all posts" />
            </Link>
          </div>
        )}
      </section>
    </section>
  );
}
